import { Tenant } from "redmond";

const CORPORATE_PORTAL_URL = window.__mclean_env__?.CORPORATE_PORTAL_URL || "";
export const isValidBusinessTravelURL = (url: string) =>
  url.startsWith(CORPORATE_PORTAL_URL);

export const isCorpTenant = (tenant: Tenant | undefined) =>
  tenant === "capone-corporate" || tenant === "brex";

export const isCaponeTenant = (tenant: Tenant | undefined) =>
  tenant === "capone";

export const isVesperTenant = (tenant: Tenant | undefined) =>
  tenant === "vesper";

export const isBrexTenant = (tenant: Tenant | undefined) =>
  tenant === "brex";

const tenants = ["capone", "capone-corporate", "vesper", "brex"] satisfies Tenant[];

// this function ensures tenant in config will always fall back to 'capone' if leamouth config is outdated
export const getConfigTenant = () => {
  const configTenant = (window.__mclean_env__?.TENANT ??
    window.__portal_env__?.TENANT ??
    process?.env?.TENANT ??
    "capone") as Tenant;

  return tenants.includes(configTenant) ? configTenant : "capone";
};
